var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartphoneDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.01L12.01 15.9989",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 20.14V3.86001C6.5 3.4955 6.79549 3.20001 7.16 3.20001H16.84C17.2045 3.20001 17.5 3.4955 17.5 3.86001V20.14C17.5 20.5045 17.2045 20.8 16.84 20.8H7.16C6.79549 20.8 6.5 20.5045 6.5 20.14Z",
    stroke: "black",
    strokeWidth: 1.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphoneDevice);
export default __webpack_public_path__ + "static/media/smartphone-device.76c92006a48b4423ac6bab2f1afc6dec.svg";
export { ForwardRef as ReactComponent };